import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { DropdownMenuItem } from "@ui-kit/Dropdown";
import { Icon } from "@ui-kit/Icon";
import { tui } from "../locale";
import { useLeadsIntoTools } from "../store/useLeadsIntoTools";
import { useWorkspaceToolsActions } from "../store/useWorkspaceToolsActions";
import { useEnabledToolsState } from "../store/useWorkspaceToolsStore";
import { OpenToolsHint } from "./OpenToolsHint";

export const WorkspaceToolsAccountItem = () => {
	const state = useEnabledToolsState();
	const currentCatalog = useCatalogPropsStore((store) => store.data?.name);
	const leadsIntoTools = useLeadsIntoTools();
	const { openLink } = useWorkspaceToolsActions();
	if (!state || !leadsIntoTools || currentCatalog === state.catalogName) return null;

	return (
		<OpenToolsHint side="left">
			<DropdownMenuItem className="rounded-lg" onSelect={() => void openLink("catalog")}>
				<div className="flex items-center gap-2" data-testid="workspace-tools-account-item">
					<Icon icon="blocks" />
					{tui("open")}
				</div>
			</DropdownMenuItem>
		</OpenToolsHint>
	);
};
